<template>
  <div>
    <vk-section class="uk-padding">
      <h1>ZOOlanders Translation Packages</h1>
      <p class="uk-text-small">Install using the Joomla! Extension Manager.</p>
    </vk-section>
    <vk-section>
      <vk-table
        :data="items"
        striped
        headless
        :fnRowClass="item => item.type"
        @rowClick="toggleFolder"
      >
        <vk-table-column cell="name" width="expanded">
          <template
            slot-scope="{ value, row: item }"
          >
            <span
              v-if="item.type === 'folder'"
            >
              <vk-icons-minus v-if="isActive(item)"/>
              <vk-icons-plus v-else/>
              <span class="uk-margin-left">{{ value }}</span>
            </span>
            <a v-else
              :href="$options.bucketUrl + '/' + item.key"
            >
              {{ value | basename }}
            </a>
          </template>
        </vk-table-column>
        <vk-table-column cell="size" width="shrinked">
          <span slot-scope="{ value, row }" v-if="row.type === 'file'">
            {{ value | formatSize }}
          </span>
        </vk-table-column>
      </vk-table>
    </vk-section>
  </div>
</template>

<script>
import $ from 'jquery'

const sourcePath = process.env.VUE_APP_PUBLIC_PATH + '/packages/'
const bucketUrl = '//' + process.env.VUE_APP_BUCKET_NAME + '.s3.amazonaws.com'

const itemIsChildOfSourceRoot = item =>
  item.key !== sourcePath && item.parentKey === sourcePath

export default {
  bucketUrl,
  name: 'App',
  data: () => ({
    bucketContents: [],
    activeFolder: ''
  }),
  methods: {
    toggleFolder (item) {
      if (item.type !== 'folder') {
        return
      }

      this.activeFolder = this.activeFolder !== item.key
        ? item.key
        : ''
    },
    isActive (item) {
      return this.activeFolder === item.key
    }
  },
  computed: {
    items () {
      let items = this.bucketContents

      // add computed data
      items = items.map(item => ({
        ...item,
        name: basename(item.key.replace(/\/$/, '')),
        type: /\/$/.test(item.key) ? 'folder' : 'file',
        levels: item.key.split('/').filter(Boolean).length,
        parentKey: item.key.match(/.*\//)[0]
      }))

      // filter
      items = items.filter(itemIsChildOfSourceRoot)

      // filter out unfolded items
      // items = items.filter(item =>
      //   item.type === 'folder' || item.parentKey === this.activeFolder
      // )

      return items
    }
  },
  filters: {
    basename,
    formatSize
  },
  async created () {
    const xml = await $.ajax(process.env.VUE_APP_BUCKET_CONTENTS_URL)

    this.bucketContents = $.makeArray(
      $(xml).find('ListBucketResult').find('Contents')
    ).map(element => ({
      lastModified: $(element).find('LastModified').text(),
      size: $(element).find('Size').text(),
      key: $(element).find('Key').text()
    }))
  }
}

function basename (str) {
  return new String(str).substring(str.lastIndexOf('/') + 1) // eslint-disable-line
}

// return e.g. 1.2KB, 1.3MB, 2GB, etc.
function formatSize (size) {
  const KB = 1024
  const MB = 1000000
  const GB = 1000000000

  size = parseInt(size, 10)

  if (size === 0) {
    return ''
  } else if (size < KB) {
    return size + 'B'
  } else if (size < MB) {
    return (size / KB).toFixed(0) + 'KB'
  } else if (size < GB) {
    return (size / MB).toFixed(2) + 'MB'
  }
  return (size / GB).toFixed(2) + 'GB'
}
</script>

<style>
.folder {
  cursor: pointer;
  padding: 0 !important;
}
</style>
